import React from "react";
import ReactQuill from 'react-quill';
//import 'react-quill/dist/quill.snow.css';
//import 'react-quill/dist/quill.core.css';

export default class Editor extends React.Component {
    //
    render () {
      return (
        <div style={{height: '300px'}}>
          <ReactQuill 
            theme={'snow'}
            style={{height: '245px'}}            
            onChange={this.props.handleChange}
            value={this.props.value}
            modules={Editor.modules}
            formats={Editor.formats}
            bounds={'.app'}
            placeholder={this.props.placeholder}
           />
         </div>
       )
    }
  }
  
  /* 
   * Quill modules to attach to editor
   * See https://quilljs.com/docs/modules/ for complete options
   */
  Editor.modules = {
    toolbar: [
      [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
      [{size: []}],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}, 
       {'indent': '-1'}, {'indent': '+1'}],
      [{ 'color': [] }, { 'background': [] }], 
      ['link', 'image'],
      ['clean']
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    }
  }
  /* 
   * Quill editor formats
   * See https://quilljs.com/docs/formats/
   */
  Editor.formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote', 'color', 'background',
    'list', 'bullet', 'indent',
    'link', 'image', 'video'
  ]
  